{
  "companyInfoFields": {
    "required": "企業名を入力してください",
    "max": "企業名は50文字以下で入力してください",
    "required2": "電話番号を入力してください",
    "phoneNumber": "電話番号を正しいフォーマットで入力してください",
    "required3": "郵便番号を入力してください",
    "postalCode": "郵便番号を正しいフォーマットで入力してください",
    "required4": "都道府県を入力してください",
    "required5": "市区町村を入力してください",
    "required6": "番地・建物名を入力してください",
    "enqueueSnackbar": "企業情報を更新しました",
    "enqueueSnackbar2": "企業情報の更新に失敗しました",
    "text": "読み込み中...",
    "alert": "企業情報の読み込みに失敗しました。ページを再読み込みしてください。",
    "label": "企業名",
    "label2": "電話番号",
    "label3": "郵便番号",
    "label4": "都道府県",
    "label5": "市区町村",
    "label6": "番地・建物名"
  },
  "samlFields": {
    "required": "IdP エンティティ ID は必須です",
    "required2": "IdP SSO エンドポイント URL は必須です",
    "matches": "https:// から始まる URL を入力してください",
    "url": "URL の形式が不正です",
    "test": "-----BEGIN CERTIFICATE----- ... -----END CERTIFICATE----- の形式で入力してください",
    "required3": "メールアドレス属性名は必須です",
    "title": "コピー",
    "ariaLabel": "{{label}}をコピー",
    "enqueueSnackbar": "{{label}}をコピーしました",
    "enqueueSnackbar2": "コピーに失敗しました",
    "message": "IdP 証明書は必須です",
    "enqueueSnackbar3": "SSO 設定を保存しました",
    "text": "SSO 設定の保存に失敗しました",
    "alert": "SSO 設定の読み込みに失敗しました。ページを再読み込みしてください。",
    "text2": "SSO を有効にする",
    "text3": "有効にするとパスワードログインに加えて SSO ログインが使えます。MFA は IdP 側で設定してください。",
    "text4": "IdP（ID 管理サービス）を選択",
    "text5": "お使いのサービスを選ぶと、入力のヒントと属性デフォルトが表示されます。",
    "label": "IdP エンティティ ID",
    "label2": "IdP SSO エンドポイント URL",
    "text6": "登録済み。証明書を更新する場合のみ新しい PEM を貼り付け（空欄なら既存を維持）",
    "text7": "IdP のメタデータ XML をダウンロードし、<X509Certificate> 内の値を BEGIN/END 行で囲って貼り付け",
    "label3": "IdP 証明書 (PEM)",
    "text8": "（登録済み — 変更する場合のみ入力）",
    "text9": "属性マッピング",
    "text10": "IdP から送られてくる属性名を入力してください。よく分からない場合はデフォルトのままで大丈夫です。",
    "text11": "ユーザー識別に使います（必須）",
    "label4": "メールアドレス属性名",
    "text12": "例: email",
    "text13": "姓として扱われます（詳細設定で「名」と組み合わせ）",
    "text14": "省略可。スペース区切りで姓名分割",
    "text15": "姓 属性名",
    "text16": "表示名 属性名",
    "text17": "例: displayName",
    "button": "詳細設定（姓・名を別属性で受け取る場合）",
    "text18": "入れると「表示名 属性名」を姓、こちらを名として組み合わせます",
    "label5": "名 属性名",
    "placeholder": "例: http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
    "text19": "jizaipad の情報を IdP に登録",
    "text20": "以下をコピーして IdP 側の設定画面に貼り付けてください。",
    "alert2": "テナント情報を読み込み中、または API オリジン (JIZAIPAD_API_URL) が未設定です。",
    "label6": "SP エンティティ ID",
    "label7": "ACS URL（コールバック URL）",
    "text21": "メールアドレスは完全一致で突合します。",
    "text22": "IdP 側と jizaipad 側でアドレスが異なると、同じ人でも別アカウントとして扱われます。",
    "text23": "jizaipad のログインには、ユーザー招待が必要です。未招待のメールアドレスでは SSO でもログインできません。",
    "title2": "IdP に登録してください",
    "text24": "SSO を有効化しました。下記の SP 情報を IdP 側で登録してください。"
  },
  "securityFields": {
    "label": "一括有効",
    "label2": "一括無効",
    "label3": "アカウントごとに設定",
    "text": "一部のセキュリティ設定の更新に失敗しました",
    "text2": "セキュリティ設定の更新に失敗しました",
    "enqueueSnackbar": "セキュリティ設定を更新しました",
    "text3": "ログイン時にメールアドレスによる本人確認を実施",
    "text4": "有効にすると、ログイン時にメールアドレスに送信される確認コードの入力が必須になります",
    "text5": "ログイン時アカウントにメールアドレス宛にお知らせメールを送信する（不正ログイン対策）",
    "text6": "一括有効もしくは一括無効にすると企業に所属するユーザー全員に適応されます。",
    "label4": "ログインお知らせ機能"
  },
  "securityForm": {
    "label": "一括有効",
    "label2": "一括無効",
    "label3": "アカウントごとに設定",
    "enqueueSnackbar": "セキュリティ設定を更新しました",
    "enqueueSnackbar2": "セキュリティ設定の更新に失敗しました",
    "enqueueSnackbar3": "ログインお知らせメール設定を更新しました",
    "enqueueSnackbar4": "ログインお知らせメール設定の更新に失敗しました",
    "title": "ログイン認証",
    "text": "ログイン時にメールアドレスによる本人確認を実施",
    "text2": "有効にすると、ログイン時にメールアドレスに送信される確認コードの入力が必須になります",
    "title2": "ログインのお知らせメール設定",
    "text3": "ログイン時アカウントにメールアドレス宛にお知らせメールを送信する（不正ログイン対策）",
    "text4": "一括有効もしくは一括無効にすると企業に所属するユーザー全員に適応されます。",
    "label4": "ログインお知らせ機能"
  },
  "companySettings": {
    "label": "一般",
    "label2": "セキュリティ",
    "label3": "SSO 設定",
    "title": "企業設定",
    "text": "更新中...",
    "title2": "企業情報",
    "ipRestrictionTab": "IP アドレス制限"
  },
  "samlIdpTemplates": {
    "hint": "Microsoft Entra ID（旧 Azure AD）を使う場合、エンタープライズアプリを作成し SAML SSO を設定してください。エンティティ ID と SSO URL は「フェデレーションメタデータ XML」から取得できます。",
    "entityIdHint": "Azure ポータル → エンタープライズアプリ → SAML → 「識別子（エンティティ ID）」",
    "ssoUrlHint": "Azure ポータル → エンタープライズアプリ → SAML → 「ログイン URL」",
    "hint2": "Okta を使う場合、Admin コンソールで「Applications」→「Create App Integration」→「SAML 2.0」を選択してください。メタデータ URL または XML から各情報を取得できます。",
    "entityIdHint2": "Okta Admin → アプリ設定 → Sign On → 「Identity Provider issuer」",
    "ssoUrlHint2": "Okta Admin → アプリ設定 → Sign On → 「Identity Provider Single Sign-On URL」",
    "hint3": "Google Workspace を使う場合、管理コンソールから「アプリ」→「ウェブアプリとモバイルアプリ」→「カスタム SAML アプリを追加」を選択してください。",
    "entityIdHint3": "Google 管理コンソール → アプリ → SAML アプリ → 「エンティティ ID」",
    "ssoUrlHint3": "Google 管理コンソール → アプリ → SAML アプリ → 「SSO URL」",
    "label": "その他",
    "hint4": "SAML 2.0 に対応した IdP であれば利用できます。お使いの IdP の管理コンソールから SAML 設定ページを開き、以下の情報を入力してください。",
    "entityIdHint4": "IdP の SAML 設定画面で「Issuer」または「Entity ID」として表示されている値",
    "ssoUrlHint4": "IdP の SAML 設定画面で「SSO URL」または「Sign-in URL」として表示されている値"
  },
  "ipRestrictionFields": {
    "loading": "読み込み中...",
    "loadError": "IP アドレス制限の設定を読み込めませんでした。ページを再読み込みしてください。",
    "toggleTitle": "IP アドレス制限",
    "toggleNote": "ON にすると、許可リストにない IP アドレスからは、ログインも操作もできなくなります。",
    "emptyHint": "許可する IP アドレスを 1 件以上追加すると、ON にできます。",
    "currentIp": "現在の IP アドレス:",
    "currentIpLabel": "現在の IP アドレス: {{ip}}",
    "addCurrentIp": "この IP を追加",
    "listTitle": "許可する IP アドレス",
    "noEntries": "許可する IP アドレスは登録されていません。",
    "columnCidr": "IP アドレス / CIDR",
    "columnMemo": "メモ",
    "columnCreatedBy": "登録者",
    "columnCreatedAt": "登録日時",
    "deleteLabel": "{{cidr}} を削除",
    "cidrLabel": "IP アドレス / CIDR",
    "cidrHelper": "単一の IPv4 アドレス、または CIDR（例: 203.0.113.0/24）",
    "memoLabel": "メモ",
    "memoHelper": "{{max}} 文字まで（任意）",
    "add": "追加",
    "invalidCidr": "IP アドレスまたは CIDR の形式が正しくありません。",
    "cidrTaken": "この IP アドレスはすでに登録されています。",
    "memoTooLong": "メモは {{max}} 文字以下で入力してください。",
    "entryLimitExceeded": "許可する IP アドレスは {{limit}} 件まで登録できます。",
    "addError": "IP アドレスの追加に失敗しました。",
    "addSnackbar": "許可する IP アドレスを追加しました",
    "deleteSnackbar": "許可する IP アドレスを削除しました",
    "deleteError": "IP アドレスの削除に失敗しました。",
    "enabledSnackbar": "IP アドレス制限を ON にしました",
    "disabledSnackbar": "IP アドレス制限を OFF にしました",
    "updateError": "IP アドレス制限の更新に失敗しました。",
    "entriesRequired": "許可リストが 1 件だけの間は削除できません。先に制限を OFF にしてください。",
    "embedNote": "jizaipad-embed は、この制限の対象外です。",
    "confirm": "実行する",
    "enableConfirmTitle": "IP アドレス制限を ON にします",
    "enableConfirmBody": "許可していない IP アドレスからは、ログインも操作もできなくなります",
    "currentIpNotAllowed": "この IP は許可リストにありません。ON にすると、この画面も使えなくなります",
    "deleteConfirmTitle": "現在の IP アドレスが許可リストから外れます",
    "deleteConfirmBody": "この IP を削除すると、この IP アドレスからこの画面も使えなくなります",
    "enableEntriesRequired": "許可する IP アドレスが 0 件のため ON にできません。1 件以上追加してください。"
  }
}
